import { Chip } from "../../../core/components/Chip/index.mjs";
import styled from "../../../core/styled-components.mjs";
import { cssSpacing } from "../../../core/styles/index.mjs";
export var ChipInputItem = styled(Chip).withConfig({
  displayName: "indexstyled__ChipInputItem",
  componentId: "sc-vvokn6-0"
})(["padding:", " ", ";&&&{display:inline-flex;}&::after{pointer-events:none;}svg{opacity:0.5;color:currentcolor;&:hover,&:active,&:focus{opacity:1;color:currentcolor;}}"], cssSpacing('tighter-2', '8px'), cssSpacing('tighter', '12px'));